import { Component } from '@angular/core';
import { ExtractsService } from '../../services/extracts-service/extracts.service';
import { Breadcrumb } from 'primeng/breadcrumb';
import { DatePipe,formatDate,NgIf } from '@angular/common';
import { MessageService } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinner } from "primeng/progressspinner";
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { Tag } from "primeng/tag";

@Component({
  selector: 'app-extract-admin',
  standalone: true,
  imports: [
    Breadcrumb,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    ToastModule,
    TableModule,
    DropdownModule,
    NgIf,
    ProgressSpinner,
    CardModule,
    MultiSelectModule,
    Tag
],
  providers: [DatePipe, MessageService],
  templateUrl: './extract-admin.component.html',
  styleUrl: './extract-admin.component.scss'
})
export class ExtractAdminComponent {
  breadcrumbHome = { icon: 'pi pi-database', to: 'extract-admin' };
  breadcrumbItems = [{ label: 'Historique des Envois' }];

  // Données
  tableItems: string[] = [];
  filteredTableList: { label: string; value: string }[] = [];
  selectedTable: string | null = null;
  isLoading: boolean = false;

  Logs: any = {};;
  Stats: any = {};
  allLogs: any[] = [];
  filteredLogs: any[] = [];
  stats: any = {};

  // Filtres
  selectedDates: string[] = [];
  selectedDo: string[] = [];
  selectedStatus: string[] = [];

  // Options de filtre
  dateOptions: any[] = [];
  doOptions: any[] = [];
  statusOptions: any[] = [];

  previewData: any[] = [];
  previewColumns: string[] = [];
  showPreviewTable: boolean = false;
  loadingPreview: boolean = false;



  rowData: any;

  constructor(
    private extractsService: ExtractsService,
    private messageService: MessageService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.LoadListTable();
    this.loadSuiviLog();
    //  this.loadStat();

  }

getStatusSeverity(status: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined {
  if (!status) return 'warn';

  const s = status.toLowerCase();

  if (s.includes('incomplet') || s.includes('échec')) {
    return 'danger';
  }

  if (s.includes('complet') || s.includes('envoyé')) {
    return 'success';
  }

  return 'info';
}


max_nb_rapport = 200;
circumference = 2 * Math.PI * 45;



getOffset(value: number): number {
  const percent = Math.min(value / this.max_nb_rapport, 1);
  return this.circumference * (1 - percent);
}

 loadSuiviLog() {
    this.isLoading = true;
    this.extractsService.api_suivi_envois().subscribe({
      next: (data: any) => {
        this.allLogs = data;

        this.initFilterOptions();

        this.applyFilters();

        this.isLoading = false;
      },
      error: (err: any) => {
        console.error('Erreur lors du chargement des Logs', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec du chargement des données'
        });
        this.isLoading = false;
      }
    });
  }



initFilterOptions() {

  const uniqueDates = [...new Set(this.allLogs.map(log => log.JOUR))];
  this.dateOptions = uniqueDates.map(d => ({ label: d, value: d }));

  const uniqueDo = [...new Set(this.allLogs.map(log => log.DO))];
  this.doOptions = uniqueDo.map(d => ({ label: d, value: d }));

  const uniqueStatus = [...new Set(this.allLogs.map(log => log.COMPLET))];
  this.statusOptions = uniqueStatus.map(s => ({ label: s, value: s }));
}

applyFilters() {

  this.filteredLogs = this.allLogs.filter(log => {
    const dateMatch = this.selectedDates.length === 0 || this.selectedDates.includes(log.JOUR);
    const doMatch = this.selectedDo.length === 0 || this.selectedDo.includes(log.DO);
    const statusMatch = this.selectedStatus.length === 0 || this.selectedStatus.includes(log.COMPLET);

    return dateMatch && doMatch && statusMatch;
  });

  this.calculateStats();
}

  calculateStats() {
    this.stats = {
      totalReports: 0,
      totalAvecDossier: 0,
      totalSansDossier: 0
    };

    this.filteredLogs.forEach(log => {
      this.stats.totalReports += log.NB_RAPPORTS || 0;
      this.stats.totalAvecDossier += log.TOTAL_AVEC_DOSSIER || 0;
      this.stats.totalSansDossier += log.TOTAL_SANS_DOSSIER || 0;
    });
  }

  onFilterChange() {
    this.applyFilters();
  }




// loadStat() {
//   this.isLoading = true;
//   this.extractsService.get_stat().subscribe({
//     next: (data: any) => {
//       console.log('Raw API Response:', data);
//       this.Stats = Array.isArray(data) ? data : [data];
//       console.log('Processed Stats:', this.Stats);

//       this.isLoading = false;
//     },
//     error: (err: any) => {
//       console.error('Error loading statistics:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//         detail: 'Failed to load statistics'
//       });
//       this.isLoading = false;
//     }
//   });
// }



 LoadListTable() {
  this.isLoading = true;
  this.extractsService.list_tables().subscribe({
    next: (data: any) => {
      const tableData = data as string[];
      this.tableItems = tableData;
      this.filteredTableList = tableData.map((name: string) => ({
        label: name,
        value: name
      }));
      this.isLoading = false;
    },
    error: (err: any) => {
      console.error('Erreur lors du chargement des tables', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Échec du chargement des tables'
      });
      this.isLoading = false;
    }
  });
}




onPreview() {
  if (!this.selectedTable) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Attention',
      detail: 'Veuillez sélectionner une table'
    });
    return;
  }

  this.loadingPreview = true;
  this.showPreviewTable = false;
  this.resetPreview();

  this.extractsService.getTableData(this.selectedTable).subscribe({
    next: (response) => {
      // Vérifiez si la réponse contient une propriété 'data'
      if (response && response.data && Array.isArray(response.data)) {
        this.previewData = response.data; // Prenez les données depuis response.data

        if (response.data.length > 0) {
          this.previewColumns = Object.keys(response.data[0]);
        }

        this.showPreviewTable = true;
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Aucune donnée',
          detail: 'Aucune donnée disponible pour cette sélection'
        });
      }
      this.loadingPreview = false;
    },
    error: (error) => {
      console.error('Erreur lors du chargement de la prévisualisation', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Impossible de charger les données de prévisualisation'
      });
      this.loadingPreview = false;
    }
  });
}

  private resetPreview() {
    this.previewData = [];
    this.previewColumns = [];
    this.showPreviewTable = false;
  }


onExtract() {
  if (!this.selectedTable) {
    this.resetPreview();
    return;
  }

  this.isLoading = true;

  this.extractsService.exportTableToCsv(this.selectedTable).subscribe({
    next: (data: Blob) => {
      const dateStr = this.datePipe.transform(new Date(), 'yyyyMMdd_HHmmss');
      const filename = `Extract_${this.selectedTable}_${dateStr}.csv`;

      // Création d'un lien de téléchargement natif
      const blobUrl = URL.createObjectURL(data);
      const link = document.createElement('a');

      link.href = blobUrl;
      link.download = filename;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      // Nettoyage
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }, 100);

      this.messageService.add({
        severity: 'success',
        summary: 'Succès',
        detail: 'Export CSV réussi'
      });
    },
    error: (error) => {
      console.error('Erreur export CSV', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Échec de l\'export CSV'
      });
    },
    complete: () => {
      this.isLoading = false;
    }
  });
}


}
